<div>
  <nestas-toolbar></nestas-toolbar>
</div>


<div class="wrap pid-component">
  <div style="margin-top: -80px; width: 100%;" class="home">
    <div style="width:100%; overflow: hidden;margin-top:20px;">

      <nestas-pidinfo *ngIf="pid && steps" [steps]="steps" [pid]="pid" [module]="this"></nestas-pidinfo>

      <div class="add-button-wrapper">

        <!--<span>UA {{userIsAllowed()}} MS {{isMineOrShared()}} No Copy {{!isCopy()}}</span>-->
        <button class="add-button-pid" [title]="(tabindex==1 && !canAddPID()) ? translate.instant('MESSAGE.PID_LIMIT_REACHED') : ''"
          *ngIf="userIsAllowed() && isMineOrShared() && !isCopy() && !pid.parentPID" (click)="addClick()">
          <span *ngIf="tabindex == 1">{{translate.instant('DATA.SUBPID')}}</span>
          <span *ngIf="tabindex == 0">{{translate.instant('DATA.FILE')}}</span>
          <i class="material-icons">add</i>
        </button>

        <div class="subpid-info" *ngIf="pid && pid.parentPID">
          <div>{{translate.instant('DATA.SUBPID')}}</div>
        </div>

        <ng-container *ngIf="tabindex == 0 && userIsAllowed() && isMineOrShared() && !isCopy()">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="hamburgermenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">

            <button mat-menu-item *ngIf="!selection" (click)="selection = true">
              <mat-icon>fact_check</mat-icon>
              <span>{{translate.instant('BUTTON.ACTION.SELECT')}}</span>
            </button>
            <button mat-menu-item *ngIf="filesAreSelected()" (click)="openDialog()">
              <!--(click)="selection = false"-->
              <mat-icon>edit</mat-icon>
              <span>{{translate.instant('BUTTON.ACTION.EDIT')}}</span>
            </button>
            <!--<button mat-menu-item *ngIf="selection" (click)="openDialog()">  
              <mat-icon>share</mat-icon>
              <span>{{translate.instant('DOCUMENT.SHARE')}}</span>
            </button>-->
            <button mat-menu-item (click)="selectAll()">
              <!--*ngIf="selection"-->
              <mat-icon>done_all</mat-icon>
              <span>{{translate.instant('PID.SELECT_ALL')}}</span>
            </button>
            <button mat-menu-item *ngIf="filesAreSelected()" (click)="selectNone()">
              <!--*ngIf="selection"-->
              <mat-icon>not_interested</mat-icon>
              <span>{{translate.instant('PID.SELECT_NONE')}}</span>
            </button>
            <button (click)="goToTemplate()" *ngIf="!pid.parentPID" mat-menu-item>
              <mat-icon>text_snippet</mat-icon>
              <span>{{translate.instant('TOOLBAR.STEP.TEMPLATE')}}</span>
            </button>
            <button (click)="addToTemplates()" *ngIf="!pid.parentPID && filesAreSelected()" mat-menu-item>
              <mat-icon>playlist_add</mat-icon>
              <span>{{translate.instant('TOOLBAR.STEP.ADD_TO_TEMPLATES')}}</span>
            </button>
          </mat-menu>
        </ng-container>

      </div>

      <div class="divsearchbar">
        <nestas-searchbar (search)="filterFct($event)" class="flexbox wrap-search small"></nestas-searchbar>
      </div>

      <div *ngIf="isPhone && fileTable" class="tabselectoricons">
        <a (click)="fileTable.showfilters = false"><img class="cards" src="/assets/listicon2.png" height="30"
            style="z-index:1">
        </a>
        <div class="mobileonly sortfilt" [ngStyle]="{'opacity' : (fileTable.showfilters) ? 0.5 : 1}">
          <span>
            <a (click)="filterOnOff()">{{translate.instant('BUTTON.ACTION.FILTER')}}</a>
            <!--<a (click)="tabindex = 1;">sorteren</a>-->
          </span>
        </div>
      </div>

    </div>


    <mat-tab-group *ngIf="tabindex > -1 && pid" #tabGroup class="mat-tab-group" [(selectedIndex)]="tabindex">

      <mat-tab>
        <!-- File table-->
        <ng-template mat-tab-label>
          {{translate.instant('DATA.ALL_FILES')}}
          <span class="material-icons-badge material-icons-badge-margin"
            *ngIf="files.all.length > 0 || pending.all.length">{{files.all.length}} <span *ngIf="pending.all.length">+
              {{pending.all.length}}</span>
          </span>
        </ng-template>

        <!--<div *ngIf="!pid.parentPID && !pid.copy" class="addsubpid"><a (click)="addSubPID()"><span>{{translate.instant('DATA.ADD_SUBPID')}}</span><i class="material-icons">add</i></a>
          <a *ngIf="pid.children.display.length > 0" (click)="tabindex=1;"><span style="margin-left:25px;">{{translate.instant('DATA.SUBPIDS')}}</span></a>
        </div>-->

        <nestas-file-table #fileTable *ngIf="files.all.length || pending.all.length" [files]="files" [pending]="pending"
          [compact]="isPhone" [selection]="selection" [showfilters]="!isPhone" [pid]="pid" editable="true"
          (reloadHome)="reload($event)" [events]="eventsSubject.asObservable()"></nestas-file-table>

        <div *ngIf="!files.all.length && !pending.all.length" class="default-placeholder-empty">
          <div class="action" *ngIf="pid && !pid.copy && !pid.parentPID">{{translate.instant('PLACEHOLDER.NO_FILE')}}
          </div>
          <div>{{translate.instant('PLACEHOLDER.NO_FILE_ENTRIES')}}</div>
        </div>

      </mat-tab>


      <mat-tab>
        <!-- SUB PID table-->
        <!--<div *ngIf="!pid.parentPID && !pid.copy" class="addsubpid"><a (click)="addSubPID()"><span>{{translate.instant('DATA.ADD_SUBPID')}}</span><i class="material-icons">add</i></a>
          <a (click)="tabindex=0;"><span style="margin-left:25px;">{{translate.instant('DATA.FILES')}}</span></a>
        </div>-->

        <ng-template mat-tab-label>
          {{translate.instant('PID.SUB_PIDS')}}
          <span class="material-icons-badge material-icons-badge-margin"
            *ngIf="pid && pid.children.display.length > 0">{{pid.children.display.length}}</span>
        </ng-template>
        <div style="margin-left: -18px;margin-right:-10px;padding-right:0">
          <nestas-pid-table #subpidTable [pids]="pid.children" [parentPID]="pid" editable="true"
            (reloadHome)="reload($event)" [events]="eventsSubject.asObservable()"></nestas-pid-table>
        </div>
      </mat-tab>


      <mat-tab>
        <!-- file list -->
        <ng-template mat-tab-label>
          {{translate.instant('DATA.FILES')}}
          <span class="material-icons-badge material-icons-badge-margin"
            *ngIf="files.all.length > 0">{{files.all.length}}</span>
        </ng-template>
        <div *ngIf="false && !files.display.length" class="default-placeholder-empty">
          <div class="action" *ngIf="pid && !pid.copy">{{translate.instant('PLACEHOLDER.NO_FILE')}}</div>
          <div>{{translate.instant('PLACEHOLDER.NO_FILE_ENTRIES')}}</div>
        </div>
        <table *ngIf="files.display.length" class="default-table default-table-responsive"
          (mouseleave)="files.selectedRow = null;">
          <tr>
            <th></th>
            <th>{{translate.instant('DATA.NAME')}}</th>
            <th>{{translate.instant('DATA.TYPE')}}</th>
            <th>{{translate.instant('DATA.DESCRIPTION')}}</th>
            <th>{{translate.instant('DATA.ROOM')}}</th>
            <th>{{translate.instant('DATA.CONTRACTOR')}}</th>
            <th>{{translate.instant('DATA.COMPLETION_DATE')}}</th>
            <th></th>
          </tr>
          <tr *ngFor="let f of duplicateFree(files.display); let idx = index;" class="default-table-line"
            [class.selected]="files.selectedRow == idx" (mouseenter)="selectRow(files, idx)">
            <td (click)="selectRow(files, idx)">
              <i class="material-icons" *ngIf="f.locked">lock</i>
            </td>
            <td [attr.data-info]="translate.instant('DATA.NAME')"
              (click)="selectRow(files, idx); goToFileDetails(f._id)" class="link-name">
              {{f.name}}
            </td>
            <td [attr.data-info]="translate.instant('DATA.TYPE')"
              (click)="selectRow(files, idx); goToFileDetails(f._id)">
              {{f.type}}</td>
            <td [attr.data-info]="translate.instant('DATA.DESCRIPTION')"
              (click)="selectRow(files, idx); goToFileDetails(f._id)">{{f.description}}</td>
            <td [attr.data-info]="translate.instant('DATA.ROOM')"
              (click)="selectRow(files, idx); goToFileDetails(f._id)">
              {{f.room}}</td>
            <td [attr.data-info]="translate.instant('DATA.CONTRACTOR')" *ngIf="f.contractor"
              class="contractor-details cursor" (click)="selectRow(files, idx); details.classList.toggle('show')"
              (mouseenter)="details.classList.add('show')" (mouseleave)="details.classList.remove('show')">
              <span class="contractor-name">
                {{f.contractor.name || f.contractor.email || f.contractor }}
                <i class="material-icons">arrow_drop_down</i>
              </span>
              <div #details class="details">
                <div>{{translate.instant('DATA.EMAIL')}}:
                  <span class="highlight">
                    <a href="mailto:{{f.contractor.email}}" class="cursor" title="">{{f.contractor.email}}</a>
                  </span>
                </div>
                <div *ngIf="f.contractor.phone">{{translate.instant('DATA.PHONE')}}:
                  <span class="highlight">{{f.contractor.phone}}</span>
                </div>
                <div class="highlight contractor-edit">
                  <i *ngIf="userIsAllowed() && isEditable(f)" class="material-icons cursor"
                    (click)="updateContractor(f)" title="{{translate.instant('MODAL.TITLE.EDIT_CONTRACTOR')}}">edit</i>
                </div>
              </div>
            </td>
            <td [attr.data-info]="translate.instant('DATA.CONTRACTOR')" *ngIf="!f.contractor" class="self-filled"
              (click)="selectRow(files, idx); goToFileDetails(f._id)">({{translate.instant('PID.SELF_FILLED')}})
            </td>
            <td [attr.data-info]="translate.instant('DATA.COMPLETION_DATE')"
              (click)="selectRow(files, idx); goToFileDetails(f._id)">
              {{f.version.date | date: 'dd/MM/yyyy'}}
            </td>
            <td [attr.data-info]="translate.instant('BUTTON.ACTION.ACTIONS')" (click)="selectRow(files, idx)">
              <div class="actions" [class.selected]="files.selectedRow == idx">
                <!--<i class="material-icons cursor" *ngIf="userIsAllowed() && isEditable(f) && !f.locked"
                 (click)="lock(f._id)">lock</i>
              <i class="material-icons cursor" *ngIf="userIsAllowed() && isEditable(f) && f.locked"
                 (click)="unlock(f._id)">lock_open</i>-->
                <i class="material-icons cursor" (click)="goToFileDetails(f._id)">input</i>
                <i *ngIf="userIsAllowed() && isEditable(f)" class="material-icons cursor" (click)="fileToUpdate = f"
                  title="{{translate.instant('MODAL.TITLE.EDIT_FILE')}}">edit</i>
                <!--<i class="material-icons cursor" (click)="getFileURL(f)">remove_red_eye</i>
              <i class="material-icons cursor" (click)="getOriginalFile(f)"
                 [title]="translate.instant('PID.DOWNLOAD_ORIGINAL')">file_download</i>-->
                <i *ngIf="userIsAllowed() && !isCopy() && !f.locked" class="material-icons cursor"
                  (click)="deleteFile(f)">delete</i>
              </div>
            </td>
          </tr>
        </table>
      </mat-tab>



      <mat-tab *ngIf="pid && !pid.parentPID && pid.children.display.length > 0">
        <ng-template mat-tab-label>
          {{translate.instant('PID.SUB_PIDS')}}
          <span class="material-icons-badge material-icons-badge-margin"
            *ngIf="pid && pid.children.display.length > 0">{{pid.children.display.length}}</span>
        </ng-template>
        <div *ngIf="pid && !pid.children.display.length" class="default-placeholder-empty">
          <div class="action" *ngIf="pid && !pid.copy">{{translate.instant('PLACEHOLDER.NO_SUB_PID')}}</div>
          <div>{{translate.instant('PLACEHOLDER.NO_SUB_PID_ENTRIES')}}</div>
        </div>
        <div class="flexbox"
          *ngIf="pid && pid.children && pid.children.display && pid.children.display.length && pid.children.all">
          <nestas-pid-card *ngFor="let h of duplicateFree(pid.children.display)" [pid]="h" [pids]="pid.children.all"
            [parentPID]="pid" editable="true"></nestas-pid-card>
        </div>
      </mat-tab>


    </mat-tab-group>
  </div>

  <modal class="preview-modal" [show]="viewFile != null" [closable]=true (closed)="viewFile = null;">
    <div class="modal-title-content">{{translate.instant('MODAL.TITLE.PREVIEW_FILE')}}</div>
    <div class="modal-body-content">
      <preview *ngIf="fileViewUrls && fileViewUrls.length" [files]="fileViewUrls"></preview>
    </div>
  </modal>

  <fsmodal *ngIf="pid" [show]="modal.newPID" [closable]=true (closed)="modal.newPID = false;">
    <div class="modal-title-content">{{translate.instant('MODAL.TITLE.NEW_PID')}}</div>
    <div class="modal-body-content">
      <div>
        <nestas-toolbar [modal]="modal"></nestas-toolbar>
      </div>
      <div class="wrap">
        <new-pid *ngIf="modal.newPID" #modalNewPID [pids]="pid.children.all" [parentPID]="pid"
          (cancelled)="modal.newPID = false;"></new-pid>
        <div style="margin-top:40px; margin-bottom:120px;">
          <button mat-stroked-button
            (click)="modal.newPID = false">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
          <button mat-raised-button (click)="createSubPID()" color="primary">
            {{translate.instant('BUTTON.ACTION.SAVE')}}
          </button>
        </div>
      </div>
    </div>
  </fsmodal>



  <fsmodal [show]="modal.newFile" [closable]=true (closed)="modal.newFile = false;">
    <div class="modal-title-content">{{translate.instant('MODAL.TITLE.ADD_FILE')}}</div>
    <div class="modal-body-content">
      <div>
        <nestas-toolbar [modal]="modal"></nestas-toolbar>
      </div>
      <div class="wrap">
        <nestas-pidinfo *ngIf="pid && steps" [steps]="steps" [pid]="pid"></nestas-pidinfo>

        <new-file *ngIf="modal.newFile" #modalNewFile [pid]="pid" (cancelled)="modal.newFile = false;"
          (completed)="newFileCompleted($event);"></new-file>

        <div style="margin-top:40px; margin-bottom:120px;">
          <button mat-stroked-button
            (click)="modal.newFile = false;">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
          <button mat-raised-button (click)="modalNewFile.addFile()" color="primary">
            {{translate.instant('BUTTON.ACTION.SAVE')}}
          </button>
        </div>
      </div>
    </div>
  </fsmodal>

  <modal [show]="fileToUpdate" [closable]=true (closed)="fileToUpdate = null;">
    <div class="modal-title-content">{{translate.instant('MODAL.TITLE.EDIT_FILE')}}</div>
    <div class="modal-body-content">
      <new-file #modalUpdateFile *ngIf="fileToUpdate" [pid]="pid" [editFile]="fileToUpdate"
        (cancelled)="fileToUpdate = null" (completed)="newFileCompleted($event);"></new-file>
    </div>
    <div class="modal-footer-content">
      <button mat-stroked-button (click)="fileToUpdate = null;">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
      <button mat-raised-button (click)="modalUpdateFile.addFile()" color="primary">
        {{translate.instant('BUTTON.ACTION.SAVE')}}
      </button>
    </div>
  </modal>

  <modal [show]="fileToEdit" [closable]=true (closed)="fileToEdit = null;">
    <div class="modal-title-content">{{translate.instant('MODAL.TITLE.UPLOAD_FILE')}}</div>
    <div class="modal-body-content" *ngIf="fileToEdit">
      <div *ngIf="fileToEdit.version && fileToEdit.version.date" class="alert-warning">
        <i class="material-icons ic-warning">warning</i>
        {{translate.instant('CONTRACTOR_UPLOAD.OVERWRITE')}}
      </div>
      <input type="file" name='file' id='file' (change)="fileChangeEvent($event)" multiple>
    </div>
    <div class="modal-footer-content">
      <button mat-stroked-button (click)="fileToEdit = null;">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
      <button mat-raised-button (click)="uploadFile()" color="primary">{{translate.instant('BUTTON.ACTION.UPDATE')}}
      </button>
    </div>
  </modal>

  <modal [show]="contractorFileToUpdate" [closable]=true (closed)="contractorFileToUpdate = null;">
    <div class="modal-title-content">{{translate.instant('MODAL.TITLE.EDIT_CONTRACTOR')}}</div>
    <div class="modal-body-content" *ngIf="contractorFileToUpdate && contractorFileToUpdate.contractor">
      <form class="full-width-form">
        <mat-form-field>
          <input matInput name="contractorUpdateName" type="text" [(ngModel)]="contractorFileToUpdate.contractor.name"
            placeholder="{{translate.instant('DATA.NAME')}}" class="full-width margin-right-md">
        </mat-form-field>
        <mat-form-field>
          <input matInput name="contractorUpdateEmail" type="email"
            [(ngModel)]="contractorFileToUpdate.contractor.email" placeholder="{{translate.instant('DATA.EMAIL')}}"
            class="full-width margin-right-md" [disabled]="contractorFileToUpdate.emailSent == true">
        </mat-form-field>

        <mat-form-field>
          <input matInput name="contractorUpdatePhone" type="text" [(ngModel)]="contractorFileToUpdate.contractor.phone"
            placeholder="{{translate.instant('DATA.PHONE')}}" class="full-width margin-right-md">
        </mat-form-field>
      </form>
    </div>
    <div class="modal-footer-content">
      <button mat-stroked-button
        (click)="contractorFileToUpdate = null;">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
      <button mat-raised-button (click)="submitContractorUpdate()" color="primary">
        {{translate.instant('BUTTON.ACTION.UPDATE')}}
      </button>
    </div>
  </modal>

  <modal [show]="modal.deleteFile" [closable]=true (closed)="modal.deleteFile = false;" class="default-pid-component">
    <div class="modal-title-content">{{translate.instant('BUTTON.ACTION.DELETE')}}</div>
    <div class="modal-body-content">
      <mat-card-title class="mat-card-title-attention">
        {{translate.instant('MESSAGE.CONFIRM_DELETE')}}
      </mat-card-title>
    </div>
    <div class="modal-footer-content">
      <button mat-stroked-button
        (click)="modal.deleteFile = false;">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
      <button mat-raised-button color="primary" (click)="confirmDeleteFile()">
        {{translate.instant('BUTTON.ACTION.DELETE')}}
      </button>
    </div>
  </modal>